import React from 'react';
import { C } from './primitives/constants';

/**
 * ErrorBoundary — catches React render errors and shows a recovery UI
 * instead of a blank/black screen.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', this.props.label || 'Component', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center h-64 gap-4 text-center px-6">
          <div className="text-2xl">!</div>
          <p className="text-sm font-medium" style={{ color: C.t2 }}>
            {this.props.label || 'This section'} failed to load
          </p>
          <p className="text-xs max-w-md" style={{ color: C.t3 }}>
            {this.state.error?.message || 'An unexpected error occurred.'}
          </p>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            className="px-4 py-1.5 rounded-full text-xs font-medium transition-colors"
            style={{ background: C.g08, border: `1px solid ${C.goldDim}`, color: C.gold }}
          >
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
